var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPaymentActive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_464_2913)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.73438 1.95312V18.2031H14.7344V16.9531H5.98438V3.20312H12.2344V6.95312H15.9844V8.20312H17.2344V6.07812L17.0469 5.89062L13.2969 2.14062L13.1094 1.95312H4.73438ZM13.4844 4.07812L15.1094 5.70312H13.4844V4.07812ZM7.23438 8.20312V9.45312H14.7344V8.20312H7.23438ZM17.8594 9.45312V10.7031C16.7969 10.8906 15.9844 11.7656 15.9844 12.8906C15.9844 14.1406 16.9219 15.0781 18.1719 15.0781H18.7969C19.2969 15.0781 19.7344 15.5156 19.7344 16.0156C19.7344 16.5156 19.2969 16.9531 18.7969 16.9531H16.6094V18.2031H17.8594V19.4531H19.1094V18.2031C20.1719 18.0156 20.9844 17.1406 20.9844 16.0156C20.9844 14.7656 20.0469 13.8281 18.7969 13.8281H18.1719C17.6719 13.8281 17.2344 13.3906 17.2344 12.8906C17.2344 12.3906 17.6719 11.9531 18.1719 11.9531H20.3594V10.7031H19.1094V9.45312H17.8594ZM7.23438 11.3281V12.5781H11.6094V11.3281H7.23438ZM12.8594 11.3281V12.5781H14.7344V11.3281H12.8594ZM7.23438 13.8281V15.0781H11.6094V13.8281H7.23438ZM12.8594 13.8281V15.0781H14.7344V13.8281H12.8594Z",
    fill: "#9C4900"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_464_2913"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0.984375 0.078125)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentActive);
export default __webpack_public_path__ + "static/media/payment_active.8db341e739ba30defe3ad2ead71d1772.svg";
export { ForwardRef as ReactComponent };